import * as React from 'react';
import { useFirstMountState } from 'react-use';
export function useApi(params) {
    const refAbortController = React.useRef();
    const isFirstMount = useFirstMountState();
    const [data, setData] = React.useState(params.initialData);
    const [status, setStatus] = React.useState('initial');
    const clear = () => {
        setData(undefined);
    };
    React.useEffect(() => {
        // Ignore first mount if initial data is supplied.
        if (isFirstMount && params.initialData) {
            return;
        }
        // Ignore if validate is supplied and returns false.
        if (params.validate && !params.validate()) {
            return;
        }
        // Setup abortable fetch.
        refAbortController.current = new AbortController();
        const signal = refAbortController.current.signal;
        // Trigger fetch with abort signal.
        doAsync(signal);
        return () => {
            // Abort pending request if re-fetching.
            refAbortController.current?.abort();
        };
        async function doAsync(signal) {
            setStatus('loading');
            const res = await fetch(params.url, {
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    Accept: 'application/json',
                },
                method: 'get',
                signal,
            });
            const resData = await res.json();
            setData(resData);
            setStatus('complete');
        }
    }, [params.url]);
    return { clear, data, status };
}
